import React from 'react';
import {ActionMenuIconButton} from '@netx/core-components/ActionMenuIconButton';
import {IconButton} from '@netx/core-components/IconButton';
import {type ReactAction} from '@netx/core/bootstrap';
import IconButtonToggle from '@netx/core-components/IconButtonToggle';

export interface ActionListItemProps {
	action: ReactAction;
	disabled?: boolean;
	loading?: boolean;
}

export const ActionListItem = ({
	action,
	disabled,
	loading,
}: ActionListItemProps) => {
	if (action.children?.length)
		return (
			<ActionMenuIconButton
				alwaysUseEllipsis
				disabled={disabled}
				actions={action.children}
				loading={loading}
			/>
		);

	if (action.selected != null) {
		return (
			<IconButtonToggle
				disabled={disabled}
				icon={action.icon}
				label={action.label}
				onToggle={() => action.cb?.()}
				on={action.selected}
			/>
		);
	}

	return (
		<IconButton
			disabled={disabled}
			icon={action.icon}
			label={action.label}
			onClick={() => action.cb?.()}
		/>
	);
};
